/**
 * errorReporter.ts
 * Fire-and-forget frontend error reporting to the platform API.
 * Never throws — safe to call from any error handler.
 */

import { authedFetch } from '@/lib/api';

export interface FrontendErrorPayload {
  type: 'js_error' | 'promise_rejection' | 'render_error';
  message: string;
  stack?: string;
  source?: string;
  lineno?: number;
  colno?: number;
  url: string;
}

export async function reportFrontendError(payload: FrontendErrorPayload): Promise<void> {
  try {
    // authedFetch injects Authorization itself — no manual token lookup.
    await authedFetch('/api/v1/errors/frontend', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...payload,
        user_agent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch {
    // Never throw from the error reporter — that would cause infinite loops
  }
}
